import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const ConfirmDialog = ({
  isOpen,
  title,
  message,
  confirmLabel = "Excluir",
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={onCancel}>
      {title && <ModalHeader toggle={onCancel}>{title}</ModalHeader>}
      <ModalBody>{message}</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel}>
          Cancelar
        </Button>
        <Button color="danger" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmDialog;
